import type { UnlimitableLimitResponse } from "@/api/cashier";
import { moneyToMajorUnits } from "@/utils/helpers";

export function getPlaceholder(
  locale: string,
  decimals: number,
  limits?: {
    min: UnlimitableLimitResponse;
    max: UnlimitableLimitResponse;
  }
): string {
  if (!limits) return "--";

  const { min, max } = limits;
  const minFormatted = (moneyToMajorUnits(min.value) ?? 0).toLocaleString(
    locale,
    {
      minimumFractionDigits: 0,
      maximumFractionDigits: decimals,
      useGrouping: true,
    }
  );
  const maxFormatted = (moneyToMajorUnits(max.value) ?? 0).toLocaleString(
    locale,
    {
      minimumFractionDigits: 0,
      maximumFractionDigits: decimals,
      useGrouping: true,
    }
  );

  if (!min.unlimited && !max.unlimited)
    return `${minFormatted} - ${maxFormatted}`;
  if (!min.unlimited && max.unlimited) return `${minFormatted} +`;
  if (min.unlimited && !max.unlimited) return `0 - ${maxFormatted}`;

  return "0 - ";
}
